import { webcall } from '@hll/driver-js-utils';

export function getAllUrlParams() {
  // https://www.jianshu.com/p/708c915fb905?a=1&b=2
  // https://www.jianshu.com/p/708c915fb905#aaa/?a=1&b=2
  // 最复杂的两种情况
  // https://www.jianshu.com/p/708c915fb905?a=1&b=2/#/aaa?c=3&d=4
  // https://www.jianshu.com/p/708c915fb905?a=1&b=2#/aaa?c=3&d=4

  let s = location.search;
  let h = location.hash;
  if (s) {
    s = s.slice(1);
    if (s[s.length - 1] === '/') {
      s = s.slice(0, -1);
    }
  }
  let sArr = s ? s.split('&') : [];
  if (h) {
    let index = h.indexOf('?');
    h = h.slice(index + 1);
  }
  let hArr = h ? h.split('&') : [];
  return [...sArr, ...hArr].reduce((acc, cur) => {
    const [key, value] = cur.split('=');
    acc[key] = decodeURIComponent(value);
    return acc;
  }, {});
}

export function getQueryByName(name) {
  const reg = new RegExp('[?&]' + name + '=([^&#/]+)');
  const str = location.href.match(reg);
  return str ? str[1] : '';
}

/**
 * 关闭webview
 */
export function closeWebView() {
  const params = getAllUrlParams();
  if (params.original_from == 3) {
    webcall({ action: 'closeWebview' });
  } else {
    webcall({ action: 'closeWebView' });
  }
}

/**
 * 滚动到指定元素
 * @param {*} elementId
 * @param {*} speed
 */
export function scrollToElementById(elementId, speed = 80) {
  let destEle = document.getElementById(elementId);
  let scrolltopTemp =
    document.documentElement.scrollTop || document.body.scrollTop;
  let rect = destEle.getBoundingClientRect();
  let top = scrolltopTemp + rect.top;
  let currentTop = scrolltopTemp;
  let requestId;
  // 采用requestAnimationFrame，平滑动画
  function step() {
    currentTop -= speed;
    if (currentTop >= top - 80) {
      window.scrollTo(0, currentTop);
      requestId = window.requestAnimationFrame(step);
    } else {
      window.cancelAnimationFrame(requestId);
    }
  }
  window.requestAnimationFrame(step);
}
